exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-image[data-v-01325ad1] {\n  width: 150px;\n  height: 150px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n", ""]);

// exports
